// Each person in a discussion gets their own colour, from Frolik's palette
// (the site's oranges plus the pink, yellow and cream event backgrounds).
// accent: the bar beside their comments; text: their name (darker, readable
// on white).
export const COMMENT_COLOURS = [
  { accent: '#FF7A00', text: '#C25500' }, // Frolik orange
  { accent: '#E2697A', text: '#B33A4E' }, // pink
  { accent: '#FFC300', text: '#8A6A00' }, // yellow
  { accent: '#98551F', text: '#98551F' }, // burnt orange
  { accent: '#F29CA3', text: '#A8424F' }, // soft pink
  { accent: '#FFB27A', text: '#B5602A' }, // peach
  { accent: '#E9D9AE', text: '#7A6420' }, // cream
  { accent: '#E8431C', text: '#B53212' }, // red-orange
];

const keyFor = (author) => String(author || 'Guest').trim().toLowerCase();

// Colours go out in the order people first commented (replies included), so
// the first eight people in a discussion all get different colours. The same
// person keeps the same colour everywhere in that discussion.
export function assignCommentColours(comments) {
  const all = [];
  const walk = (list) => (Array.isArray(list) ? list : []).forEach((comment) => {
    all.push(comment);
    walk(comment.replies);
  });
  walk(comments);
  all.sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0));

  const colours = new Map();
  all.forEach((comment) => {
    const key = keyFor(comment.author);
    if (!colours.has(key)) colours.set(key, COMMENT_COLOURS[colours.size % COMMENT_COLOURS.length]);
  });
  return (author) => colours.get(keyFor(author)) || COMMENT_COLOURS[0];
}
